import { render, staticRenderFns } from "./AlterarKitDinamico.vue?vue&type=template&id=4f02e5fe"
import script from "./AlterarKitDinamico.vue?vue&type=script&lang=ts"
export * from "./AlterarKitDinamico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports